class mediaGallery extends HTMLElement {
  constructor() {
    super();
    this.isMobile = window.innerWidth < 1024;
    this.sectionId = this.dataset.sectionId;
    this.pagination = this.dataset.pagination === 'true';
    this.mobileSpaceBetween = parseInt(this.dataset.mobileSpaceBetween || '10', 10);
    this.desktopSpaceBetween = parseInt(this.dataset.desktopSpaceBetween || '20', 10);
    this.mainSwiper = null;
    this.thumbsSwiper = null;

    this.container = this.querySelector('[data-media-gallery]');
    this.wrapper = this.container?.querySelector('div');
    this.slides = this.wrapper?.children ? Array.from(this.wrapper.children) : [];

    this.thumbsContainer = this.querySelector('[data-thumbnails-gallery]');
  }

  connectedCallback() {
    this.initButton();
    this.initSwipers();
    this.handleResize();
  }

  initButton() {
    const button = this.querySelector('button');
    if (!button) return;

    button.addEventListener('click', () => {
      const images = this.querySelectorAll('[data-main-gallery-image]');
      if (images.length <= 6) return;
      images[6]?.click();
    });
  }

  initSwipers() {
    // init thumbs (sempre su mobile)
    if (this.isMobile && this.thumbsContainer && !this.thumbsSwiper) {
      this.thumbsSwiper = new Swiper(this.thumbsContainer, {
        spaceBetween: 8,
        slidesPerView: 'auto',
        freeMode: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
      });
    }

    // init main swiper solo su mobile
    if (this.isMobile) {
      this.container.classList.add('swiper');
      this.wrapper.classList.add('swiper-wrapper');
      this.slides.forEach((slide) => slide.classList.add('swiper-slide'));

      if (!this.mainSwiper) {
        this.mainSwiper = new Swiper(this.container, {
          spaceBetween: this.mobileSpaceBetween,
          slidesPerView: 'auto',
          speed: 600,
          thumbs: this.thumbsSwiper ? { swiper: this.thumbsSwiper } : undefined,
        });
      }
    } else {
      this.destroySwipers();
    }
  }

  destroySwipers() {
    if (this.mainSwiper) {
      this.mainSwiper.destroy(true, true);
      this.mainSwiper = null;
    }
    if (this.thumbsSwiper) {
      this.thumbsSwiper.destroy(true, true);
      this.thumbsSwiper = null;
    }

    // ripulisci classi
    this.container.classList.remove('swiper');
    this.wrapper.classList.remove('swiper-wrapper');
    this.slides.forEach((slide) => slide.classList.remove('swiper-slide'));
  }

  handleResize() {
    window.addEventListener('resize', () => {
      const wasMobile = this.isMobile;
      this.isMobile = window.innerWidth < 1024;

      if (wasMobile !== this.isMobile) {
        this.destroySwipers();
        this.initSwipers();
      }
    });
  }
}

if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', mediaGallery);
}
